import {
  FETCH_NOTICE_SUCCESS,
  FETCH_NOTICE,
  FETCH_NOTICE_FAIL,
  POST_NOTICE,
  POST_NOTICE_SUCCESS,
  POST_NOTICE_FAIL,
  DELETE_NOTICE,
  DELETE_NOTICE_SUCCESS,
  DELETE_NOTICE_FAIL,
  RESET_NOTICE
} from './types'

export const fetchNotice = (id) => async (dispatch, getState, api) => {
  dispatch({
    type: FETCH_NOTICE
  })
  try {
    const res = await api.get(`notices/${id}`)
    if (res.data.success === true) {
      dispatch({
        type: FETCH_NOTICE_SUCCESS,
        payload: res.data.data
      })
    }
  } catch (error) {
    console.warn(error)
    dispatch({
      type: FETCH_NOTICE_FAIL
    })
  }
}

export const postNotice = (data, image, success, fail) => async (dispatch, getState, api) => {
  dispatch({ type: POST_NOTICE })
  try {
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }

    const formData = new FormData()
    Object.keys(data).forEach((key) => {
      if (typeof data[key] === 'object') {
        formData.append(key, JSON.stringify(data[key]))
      } else {
        formData.append(key, data[key])
      }
    })
    // formData.append('data', JSON.stringify(data))

    if (image) {
      formData.append('image', image)
    }

    const res = await api.post(`notices`, formData, config)
    if (res.data.success) {
      dispatch({ type: POST_NOTICE_SUCCESS })
      if (success) success()
    } else {
      dispatch({ type: POST_NOTICE_FAIL })
      if (fail) fail(res.data.message)
    }
  } catch (error) {
    if (error.code === 'ECONNABORTED') {
      dispatch({ type: POST_NOTICE_SUCCESS })
      if (success) success()
      return
    }
    dispatch({ type: POST_NOTICE_FAIL })
    if (fail) fail()
  }
}

export const deleteNotice = (id, success, fail) => async (dispatch, getState, api) => {
  dispatch({ type: DELETE_NOTICE })
  try {
    const res = await api.delete(`notices/${id}`)
    if (res.data.success) {
      dispatch({ type: DELETE_NOTICE_SUCCESS })
      if (success) success()
    } else {
      dispatch({ type: DELETE_NOTICE_FAIL })
      if (fail) fail(res.data.message)
    }
  } catch (error) {
    dispatch({ type: DELETE_NOTICE_FAIL })
    if (fail) fail()
  }
}

export const resetNotice = () => {
  return { type: RESET_NOTICE }
}
